import { create } from 'zustand';

/**
 * "A newer deployment is live than the one this tab is running." Written by
 * `VersionWatcher` in the root layout, read by the dashboard nav — a store rather than
 * local state only because those live in different trees.
 *
 * One-way: nothing clears the flag, since only a reload can resolve it.
 */
interface AppVersionState {
  updateAvailable: boolean;
  markUpdateAvailable: () => void;
}

export const useAppVersionStore = create<AppVersionState>((set) => ({
  updateAvailable: false,
  markUpdateAvailable: () => set({ updateAvailable: true }),
}));
